import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d785afb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "streaks-table" }
const _hoisted_2 = {
  key: 0,
  class: "streaks-table__desktop"
}
const _hoisted_3 = { class: "streaks-table__badges" }
const _hoisted_4 = { class: "streaks-table__actions" }
const _hoisted_5 = { class: "streaks-table__pagination" }
const _hoisted_6 = {
  key: 1,
  class: "streaks-table__mobile"
}
const _hoisted_7 = { class: "streaks-table__cards" }
const _hoisted_8 = { class: "streaks-table__card-header" }
const _hoisted_9 = { class: "text-base" }
const _hoisted_10 = { class: "streaks-table__card-content" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "streaks-table__card-label" }, " Projects: ", -1))
const _hoisted_12 = { class: "streaks-table__badges" }
const _hoisted_13 = { class: "streaks-table__card-date" }
const _hoisted_14 = { class: "streaks-table__card-actions" }
const _hoisted_15 = { class: "streaks-table__pagination" }

import type { QTableProps } from 'quasar';
import type { PropType } from 'vue';
import { computed, ref } from 'vue';

import DSTable from '@/design-system/DSTable.vue';
import DSCard from '@/design-system/DSCard.vue';
import DSButton from '@/design-system/DSButton.vue';
import DSBadge from '@/design-system/DSBadge.vue';

import { useStore } from '@/store';

import DCDeleteStreak from '@/components/streaks/partials/DCDeleteStreak.vue';
import DCEditStreak from '@/components/streaks/partials/DCEditStreak.vue';
import StreakInterface from '@/interfaces/Streak.interface';
import StreakOffensive from '@/design-system/StreakOffensive.vue';

import formatDate from '@/hooks/formatDate';


export default /*#__PURE__*/_defineComponent({
  __name: 'DCStreaksTable',
  props: {
  streaks: {
    type: Array as PropType<StreakInterface[]>,
    default: () => [],
  }
},
  setup(__props) {

const props = __props;

const deleteStreakModal = ref(DCDeleteStreak);
const editStreakModal = ref(DCEditStreak);
const store = useStore();

const request_pending = computed(() => {
  const { streak: streak_request_pending = {} } = store.state.requests_pending;
  return streak_request_pending.fetch_all;
});



const columns: QTableProps['columns'] = [
  {
    name: 'offensive',
    field: 'offensive',
    label: '',
    style: 'width: 80px',
  },
  {
    name: 'Name',
    field: 'name',
    label: 'Name',
    align: 'left',
  },
  {
    name: 'projects',
    field: (row) => row.projects?.map(({ name }: { name: string }) => name),
    label: 'Projects',
    align: 'left',
    style: 'min-width: 200px',
  },
  {
    name: 'createdAt',
    field: (row) => formatDate(new Date(row.createdAt)),
    label: 'Created at',
    align: 'left',
    style: 'min-width: 150px',
  },
  {
    name: 'actions',
    field: 'id',
    label: '',
    align: 'right',
    style: 'width: 160px',
  },
];

const rows = computed(() => props.streaks);
const getStreakOffensive = (streak: StreakInterface) => {
  return streak.offensive as { days: number; today_is_in_streak: boolean };
};

const handleDeleteButtonClick = (streak: StreakInterface) => deleteStreakModal.value.handleOpenModal(streak);
const handleEditStreakButtonClick = (streak: StreakInterface) => editStreakModal.value.handleOpenModal(streak);

const getProjectVariant = (index: number): 'primary' | 'secondary' | 'success' | 'warning' => {
  const variants: Array<'primary' | 'secondary' | 'success' | 'warning'> = ['primary', 'secondary', 'success', 'warning'];
  return variants[index % variants.length];
};

const pagination = ref({
  sortBy: 'desc',
  descending: false,
  page: 2,
  rowsPerPage: 100
});

const pagesNumber = computed(() => Math.ceil(rows.value.length / pagination.value.rowsPerPage));

return (_ctx: any,_cache: any) => {
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_pagination = _resolveComponent("q-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$q.screen.gt.xs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(DSTable, {
            columns: columns,
            rows: rows.value,
            loading: request_pending.value,
            "rows-per-page-options": [25, 50, 100],
            dense: "",
            "sticky-header": "",
            class: "streaks-table__table"
          }, {
            "body-cell-offensive": _withCtx(({ value }) => [
              _createVNode(_component_q_td, { style: {"width":"60px"} }, {
                default: _withCtx(() => [
                  _createVNode(StreakOffensive, { offensive: value }, null, 8, ["offensive"])
                ]),
                _: 2
              }, 1024)
            ]),
            "body-cell-projects": _withCtx((props_row) => [
              _createVNode(_component_q_td, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    (! props_row.value.length)
                      ? (_openBlock(), _createBlock(DSBadge, {
                          key: 0,
                          label: "No projects",
                          variant: "info",
                          size: "sm",
                          outline: ""
                        }))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props_row.value, (project, index) => {
                      return (_openBlock(), _createBlock(DSBadge, {
                        key: project,
                        label: project,
                        variant: getProjectVariant(index),
                        size: "sm",
                        class: "streaks-table__project-badge"
                      }, null, 8, ["label", "variant"]))
                    }), 128))
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            "body-cell-actions": _withCtx((action_props) => [
              _createVNode(_component_q_td, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(DSButton, {
                      icon: "visibility",
                      variant: "ghost",
                      size: "sm",
                      class: "streaks-table__action-btn",
                      onClick: ($event: any) => (_ctx.$router.push(`/streaks/${action_props.value}`)),
                      "aria-label": "View streak"
                    }, null, 8, ["onClick"]),
                    _createVNode(DSButton, {
                      icon: "edit",
                      variant: "secondary",
                      size: "sm",
                      class: "streaks-table__action-btn",
                      onClick: ($event: any) => (handleEditStreakButtonClick(action_props.row)),
                      "aria-label": "Edit streak"
                    }, null, 8, ["onClick"]),
                    _createVNode(DSButton, {
                      icon: "delete",
                      variant: "danger",
                      size: "sm",
                      class: "streaks-table__action-btn",
                      onClick: ($event: any) => (handleDeleteButtonClick(action_props.row)),
                      "aria-label": "Delete streak"
                    }, null, 8, ["onClick"])
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["rows", "loading"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_q_pagination, {
              modelValue: pagination.value.page,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pagination.value.page) = $event)),
              color: "grey-8",
              max: pagesNumber.value,
              size: "sm"
            }, null, 8, ["modelValue", "max"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (streak) => {
              return (_openBlock(), _createBlock(DSCard, {
                key: streak.id,
                class: "streaks-table__card"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(StreakOffensive, {
                      offensive: getStreakOffensive(streak)
                    }, null, 8, ["offensive"]),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(streak.name), 1)
                  ])
                ]),
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      (! streak.projects.length)
                        ? (_openBlock(), _createBlock(DSBadge, {
                            key: 0,
                            label: "No projects",
                            variant: "info",
                            size: "sm",
                            outline: ""
                          }))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(streak.projects, (project, index) => {
                        return (_openBlock(), _createBlock(DSBadge, {
                          key: project.name,
                          label: project.name,
                          variant: getProjectVariant(index),
                          size: "sm",
                          class: "streaks-table__project-badge"
                        }, null, 8, ["label", "variant"]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(formatDate)(new Date(streak.createdAt))), 1)
                  ])
                ]),
                footer: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(DSButton, {
                      icon: "visibility",
                      variant: "ghost",
                      size: "sm",
                      class: "streaks-table__action-btn",
                      onClick: ($event: any) => (_ctx.$router.push(`/streaks/${streak.id}`)),
                      "aria-label": "View streak"
                    }, null, 8, ["onClick"]),
                    _createVNode(DSButton, {
                      icon: "edit",
                      variant: "secondary",
                      size: "sm",
                      class: "streaks-table__action-btn",
                      onClick: ($event: any) => (handleEditStreakButtonClick(streak)),
                      "aria-label": "Edit streak"
                    }, null, 8, ["onClick"]),
                    _createVNode(DSButton, {
                      icon: "delete",
                      variant: "danger",
                      size: "sm",
                      class: "streaks-table__action-btn",
                      onClick: ($event: any) => (handleDeleteButtonClick(streak)),
                      "aria-label": "Delete streak"
                    }, null, 8, ["onClick"])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_q_pagination, {
              modelValue: pagination.value.page,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pagination.value.page) = $event)),
              color: "grey-8",
              max: pagesNumber.value,
              size: "sm"
            }, null, 8, ["modelValue", "max"])
          ])
        ])),
    _createVNode(DCDeleteStreak, {
      ref_key: "deleteStreakModal",
      ref: deleteStreakModal
    }, null, 512),
    _createVNode(DCEditStreak, {
      ref_key: "editStreakModal",
      ref: editStreakModal
    }, null, 512)
  ]))
}
}

})